/**
 * The playback direction of the animation.
 */
export var AnimationDirection;
(function (AnimationDirection) {
    AnimationDirection["forward"] = "forward";
    AnimationDirection["reverse"] = "reverse";
})(AnimationDirection || (AnimationDirection = {}));
//# sourceMappingURL=animation-direction.js.map